/*global myModal, logger, inputDirectionChange */

var cancellation = {
    p: $('.modal'),
    init: function() {
        $('.cancellation-request').on('click', function(e) {
            e.preventDefault();
            const modalTitle = $(this).data('title');
            const modalId = $(this).data('modal-id') || 'cancellationRequestModal';

            myModal.staticModal(modalId, {title: modalTitle, gtmEvent: 'cancellationRequest'});

            $.postJSON(_d.url.reservation.modification.check, $('#cancellation-form').serialize(), function(response) {
                if (response.reload) {
                    window.location.href = _d.url.c;
                } else {
                    cancellation.p.find('#loader-bar').addClass('dc-ui hidden');
                    cancellation.p.find('#cancellation-form').removeClass('dc-ui hidden');
                }

                inputDirectionChange.onChangeAction('input,textarea');
            });
        });
        cancellation.p.on('click', '#closeCancellationBtn', function(e) {
            e.preventDefault();
            myModal.close();
        });

        cancellation.p.on('click', '#cancellationBtn', function() {
            var btn = cancellation.p.find('#cancellationBtn');

            cancellation.p.find('.error').removeClass('error');

            cancellation.p.find('#cancellation-form').validate({
                errorClass: 'error',
                focusInvalid: false,
                errorElement: 'div',
                rules: {
                    modification_reason: {
                        required: true
                    },
                    modification_comment: {
                        required: true
                    }
                },
                errorPlacement: function(error, element) {
                    if (element.attr('name') === 'modification_reason') {
                        $(element).parent().next().html(error);
                    } else {
                        $(element).next().html(error);
                    }
                },
                highlight: function(el, ec) {
                    var ele = $(el),
                        is_select = (ele[0].localName === 'select');

                    ele.addClass(ec);
                    is_select ? ele.parent().addClass(ec) : '';
                },
                unhighlight: function(el, ec) {
                    var ele = $(el),
                        is_select = (ele[0].localName === 'select');

                    ele.removeClass(ec);
                    is_select ? ele.parent().removeClass(ec) : '';
                },
                invalidHandler: function() {
                    btn.removeClass('loading');
                },
                submitHandler: function() {
                    btn.prop('disabled', true);

                    $.postJSON(_d.url.reservation.modification.request, cancellation.p.find('#cancellation-form').serialize(), function(response) {
                        if (!response.error) {
                            let cancellationRequestBtn = $('#cancellation-request-btn, #cancellation-request-modal-btn');
                            cancellationRequestBtn.prop('disabled', true);
                            $('.cancellation-request').hide();
                            $('#alternative-block').hide();
                            $('#cancellation-in-progress').show();
                            $('.cancellation-submitted').removeClass('hide');
                            cancellation.p.find('#cancellation-form').hide();
                            cancellation.p.find('.cancellation-request-ok').show();
                            $('#modify-btn').removeClass('submit').addClass('disabled').attr('href', 'javascript: void(0);');
                            $('#booking-status').removeClass('badge-confirmed badge-awaiting badge-action-required').addClass('badge-default').text(cancellationRequestBtn.data('request-submitted'));

                            try {
                                dataLayer.push({
                                    'cancellationRequestSubmitted': {
                                        'value': cancellation.p.find('#cancellation-reason option:selected').data('reason')
                                    },
                                    'event': 'cancellationRequestSubmitted'
                                });

                                window.hj=window.hj||function() { (hj.q=hj.q||[]).push(arguments); }; //make sure we can reach out window.hj attribute
                                window.hj('trigger', 'cancellationRequestSubmitted');

                                if (['en', 'uk'].indexOf(_d.s.language)!== -1 && btn.data('booking-credit') === true) {
                                    window.hj=window.hj||function() { (hj.q=hj.q||[]).push(arguments); }; //make sure we can reach out window.hj attribute
                                    window.hj('trigger', 'receivingBookingCredit');
                                }

                            } catch (err) {}
                        } else {
                            btn.removeClass('loading').prop('disabled', false);
                        }
                    });
                }
            });
        });
    }
};
